import React, { useState } from 'react';

import LivePage from './LivePage';
import _ from 'lodash';
import ImageAnnotationsEditor from '../components/images/ImageAnnotationsEditor';
import submenuTests from './menus/submenu-tests';
import TemplatedFuseboxDiagram from '../components/lego/fusebox-editor/TemplatedFuseboxDiagram';
import LegoIdEditor from '../components/lego/LegoIdEditor';
import LegoEditor from '../components/lego/LegoEditor';
import FuseboxLegoEditor from '../components/lego/fusebox-editor/FuseboxLegoEditor';
import LegoContextSummary from '../components/lego/LegoContextSummary';

export default class TestPage extends LivePage {
  constructor(props) {
    super(props);

    const sampleAnnotations = [
      { id: 'carBox',
        "type": "boundingBox",
        "left": 0.05401684359183356,
        "top": 0.45557562384545525,
        "width": 0.8764704007024827,
        "height": 0.5373767011370797
      },
    ];

    this.state = {
      ...this.state,
      annotations: sampleAnnotations,
    };

    this.fullScreen = true;
    
    this.submenu = submenuTests;
  }

  componentDidMount() {
    super.componentDidMount();
    this.loadFusebox(this.getUrlParam('fuseboxId'));
  }

  async loadFusebox(id) {
    const ids = [
      '61a8f5d0da44ba0004adcb55',
      '61abc2cbd63c7300049684e1',
      '67586a7e4b1c3ec7c16032c8',
      '61ab5e31d63c730004968129'
    ]
    id = id || ids[0];
    const fusebox = await this.service('services/legos').get(id);
    this.setUrlParam('fuseboxId', id);
    this.setState({ fusebox });
  }

  handleAnnotationChange = (obj) => {
    this.setState({ annotations: obj.annotations });  
  }

  renderPageBody() {
    // return this.renderAnnotations();
    return this.renderFusebox();
  }


  renderFusebox() {
    if(!this.state.fusebox) {
      return <div>Loading...</div>;
    }

    let lego = this.state.fusebox;

    return <>
      <div className='d-flex align-items-center'>
        <LegoIdEditor value={this.state.fusebox?._id} onChange={id => this.loadFusebox(id)} warnDifferentLocale={true} className={'my-2'} small={true} />
        <LegoContextSummary context={lego.context} inline />
      </div>
      {/* <div style={{ width: '100svw', height: '100svh', position: 'fixed', 
        inset: 0, border: '2px solid magenta', zIndex: 10000000, pointerEvents: 'none', overscrollBehavior: 'contain', overflow: 'scroll' }} /> */}

      {/* <FuseboxLegoEditor isTemplate={lego.type === 'fuseboxTemplate'} lego={lego} openedFusebox={this.props.openedFusebox} onChange={(json) => this.alert('NO EDITION HERE')} value={lego.data} changed={lego.data}/> */}

      <TemplatedFuseboxDiagram fitScreen fitMargins={{top: 200}} showRotateButton fusebox={this.state.fusebox?.data?.[0]}/>
      {/* <TemplatedFuseboxDiagram fitScreen fitMargins={{top: 200}} showRotateButton fusebox={this.state.fusebox?.data?.[1]}/> */}
      {/* <TemplatedFuseboxDiagram fitScreen fitMargins={{top: 200}} showRotateButton fusebox={this.state.fusebox?.data?.[2]}/> */}
    </>
  }

  renderAnnotations() {
    const url = 'https://build.ford.com/dig/Ford/F-150%20F-150/2024/HD-FULL/Image%5B%7CFord%7CF-150%20F-150%7C2024%7C1%7C1.%7C801A..145.PUM..88R.89B.SS5.573.BSHDF.BY1AM.CCAB.64B.AWD.998.67T.50M.77R.%5D/EXT/5/vehicle.png';
    const url2 = 'https://tmnaassetscs.scene7.com/is/image/tmnaassetscs/vcr/live/vehicle/TOY/2025/tacoma/7568/632/f6b1ecd0c7c4b610ddf1ccd81443b8acd7d75b60a1099148d5885b70a9291218.png?wid=3200&fmt=webp-alpha&cropN=0.04,0.08,0.92,.84'
    const { annotations } = this.state;
    return <div className={'margin'}>
      <h2>Image Annotations Editor Test</h2>

      <div className="d-flex">

        <div style={{ width: '100%', height: '600px', border: '1px solid #ccc' }}>
          <ImageAnnotationsEditor
            value={{ url: url2, annotations }}
            onChange={this.handleAnnotationChange}
          />
        </div>
        <div className="mt-3">
          <pre>{JSON.stringify(this.state.annotations, null, 2)}</pre>
        </div>
      </div>
    </div>;
  }
}
